import React from "react";
import { formatDistance } from "date-fns";
import { Tooltip } from "@/components/common/Tooltip";
import { formatDayMonthYearTime } from "@/lib/dates";

interface RelativeDateProps {
  date: Date | null;
  showCreated?: boolean;
}

export const RelativeDate: React.FC<RelativeDateProps> = ({
  date,
  showCreated = true,
}) => {
  if (!date) {
    return null;
  }

  try {
    const parsedDate = new Date(date);
    if (isNaN(parsedDate.getTime())) throw new Error("Invalid date");

    const now = new Date();
    const formattedRelativeTime = formatDistance(parsedDate, now, {
      addSuffix: true,
    });
    const formattedExactDate = formatDayMonthYearTime(parsedDate);

    const displayText = showCreated
      ? `Created ${formattedRelativeTime}`
      : formattedRelativeTime;

    return (
      <Tooltip title={formattedExactDate}>
        <span className="cursor-default">{displayText}</span>
      </Tooltip>
    );
  } catch (_error) {
    return <div>{String(new Date())}</div>;
  }
};
